module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/success-2-44ed8b0db3aea506cd7fae1e14316064.png";